import { useCallback } from "react";

import { queryClient } from "../../../services";

import { userQueryKeyPrefix } from "./user.query";

// #######################
// ## useInvalidateUser ##
// #######################

export type ResultOfUseInvalidateUser = () => Promise<void>;
export type UseInvalidateUser = () => ResultOfUseInvalidateUser;

/**
 * Invalidates the user data.
 * A fresh fetch of data will be initiated when an instance of useUser is active.
 */
export const useInvalidateUser: UseInvalidateUser = () => {
  return useCallback(async () => {
    await queryClient.invalidateQueries(userQueryKeyPrefix);
  }, []);
};

// ##################
// ## useClearUser ##
// ##################

export type ResultOfUseClearUser = () => Promise<void>;
export type UseClearUser = () => ResultOfUseClearUser;

/**
 * Clears and invalidates the user data.
 * A fresh fetch of data will be initiated when an instance of `useUser` is active.
 */
export const useClearUser: UseClearUser = () => {
  return useCallback(async () => {
    await queryClient.resetQueries(userQueryKeyPrefix);
  }, []);
};
